import { RouteConfig } from 'vue-router'

import {
	WorkSheetsIndex,
  PayrollView
} from '@/views'

const workSheetsRouter: Array<RouteConfig> = [
	{
    path: 'work-sheets',
    name: 'work-sheets',
    component: WorkSheetsIndex,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Planillas'
    }
  },
  {
    path: 'payroll',
    name: 'payroll',
    component: PayrollView,
    meta: {
      requiresVisitor: false,
      requiresAuth: true,
      title: 'Planilla'
    }
  }
]

export default workSheetsRouter
